<template>
  <div v-if="!isLoading">
    <template v-if="filterStore.store && filterStore.family">
      <ShopCart :store="filterStore.store" />
      <div class="content-page">
        <section class="content-products">
          <div class="container">
            <div class="brand-filter">
              <div class="content-brand">
                <GoToBackButton />
                <div class="content-brand-elements d-none d-lg-block">
                  <router-link tag="a" :to="{ name: 'Home' }" class="content-brand-elements-links">
                    Ínicio
                  </router-link>
                  <span> > </span>
                  <router-link tag="a" :to="{
                    name: 'HomeStore',
                    params: { slug: filterStore.partner.slug }
                  }" class="content-brand-elements-links">
                    {{ filterStore.store.product.name }}
                    <span>></span>
                  </router-link>
                  <a class="content-brand-elements-links">
                    {{ filterStore.family.name }}
                  </a>
                </div>
              </div>
              <button class="btn-filter d-lg-none" @click="setActiveFilterCategories(true)">
                <p>Filtrar</p>
                <img class="img-fluid" src="@/assets/img/icons/filter.png" alt="icon filter" title="icon filter" />
              </button>
            </div>
          </div>
          <div class="content-products-title container">
            <h1>
              Produtos<span>{{ filterStore.family.name }}</span>
            </h1>
          </div>
          <div class="content-products-body container">
            <div class="row w-100">
              <div class="col-lg-4">
                <div class="content-filter" :class="{ 'active-filter-categories': activeFilterCategories }">
                  <div class="content-filter-btn d-lg-none">
                    <button class="content-filter-btn-close" @click="setActiveFilterCategories(false)">
                      <img class="img-fluid" src="@/assets/img/icons/close.png" alt="icon close" title="icon close" />
                    </button>
                  </div>
                  <div class="content-filter-elements">
                    <div class="content-filter-elements-title">
                      <p>Filtrar por</p>
                    </div>
                    <div class="content-filter-elements-selected" v-for="i in selected" :key="i">
                      <div class="content-items-selected">
                        <button @click="remove(i)" class="content-items-selected-btn">
                          <svg xmlns="http://www.w3.org/2000/svg" width="11.793" height="11.793"
                            viewBox="0 0 11.793 11.793">
                            <g transform="translate(-57.743 -531.984) rotate(45)">
                              <line x2="15.677" transform="translate(417.5 335.339)" fill="none" stroke="red"
                                stroke-width="1" />
                              <line x2="15.677" transform="translate(425.339 327.5) rotate(90)" fill="none" stroke="red"
                                stroke-width="1" />
                            </g>
                          </svg>
                          <p>{{ changeText(i) }}</p>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="content-filter-elements">
                    <div class="content-filter-elements-collapse">
                      <div>
                        <button v-b-toggle="`text${filterStore.family.id}`" class="btn-collapse">
                          <p>{{ filterStore.family.name }}</p>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8.5" viewBox="0 0 16 8.5">
                            <path d="M15,0,7.5,7.5ZM0,0,7.5,7.5Z" transform="translate(15.5 8) rotate(180)" fill="none"
                              stroke="var( --green-medium)" stroke-linejoin="round" stroke-width="1" />
                          </svg>
                        </button>
                        <!-- Element to collapse -->
                        <b-collapse :id="`text${filterStore.family.id}`">
                          <div class="content-collapse-input-check checkbox-group">
                            <div class="content-collapse-input-check checkbox-group"
                              v-for="(obj, i) in filterStore.family.subfamilies" :key="i">
                              <div class="content-check">
                                <input type="checkbox" :id="`checkbox${obj.id}`" :value="`${obj.name}-${obj.id}`"
                                  v-model="selected" @change="toggleItem(obj)" />
                                <label class="" :for="`checkbox${obj.id}`">
                                  <span class="content-collapse-input-check-text">{{
                                      obj.name
                                  }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                  <button class="btn-send-filter" @click="getProducts()">
                    Filtrar
                  </button>
                </div>
                <div class="content-ads d-none d-lg-flex">
                  <div v-if="!publicities.image_halfpage">
                    <img class="img-fluid" src="@/assets/img/hearth/image-ads.png" alt="image ads" title="image ads" />
                  </div>
                  <a v-else :href="publicities.image_halfpage_url" target="_blank" rel="noopener">
                    <img class="img-fluid" :src="publicities.image_halfpage.path" alt="image ads" title="image ads" />
                  </a>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="content-products-body-products row">
                  <div class="col-12 col-sm-6" v-for="(prod, proIdx) in products" :key="proIdx">
                    <CardProduct :product="prod" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CategoryStore :categories="options" :slug="this.slug" />
        <MenuCart />
        <section class="partner-content container">
          <div class="togoback bottom">
            <div class="content-brand w-100 mb-0">
              <GoToBackButton />
            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import CardProduct from "@/components/cards/CardProduct.vue";
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";
import CategoryStore from "../components/CategoryStore.vue";
import MenuCart from "../components/MenuCart.vue";
import ShopCart from "../components/ShopCart.vue";

export default {
  data() {
    return {
      slug: this.$route.params.slug,
      family: '',
      filter_name: "",
      subfamily: [],
      isLoading: true,
      selected: [],
      selected_filters: [],
    };
  },
  components: {
    CardProduct,
    CategoryStore,
    MenuCart,
    GoToBackButton,
    ShopCart,
  },

  computed: {
    ...mapGetters(["activeFilterCategories"]),
    ...mapGetters({
      products: "Products/products",
      options: "Products/productsFilters",
      publicities: "Publicity/publicities",
      filterStore: "Products/FilterStore/filterList",
    }),
  },

  methods: {
    ...mapActions(["setActiveFilterCategories"]),
    getProducts(value) {
      if (!value && !this.selected_filters.length) {
        this.family = this.$route.params.family;
        this.filterPageByFamily();
      } else {
        this.filterPage();
      }
    },
    remove(obj) {
      this.selected.splice(this.selected.indexOf(obj), 1);
      const arrayObj = obj.split("-");
      const objFilter = { filter_name: arrayObj[0], id: parseInt(arrayObj[1]) };
      this.toggleItem(objFilter);
    },
    toggleItem(obj) {
      if (this.selected_filters != null || this.selected_filters != "") {
        const index = this.selected_filters.indexOf(obj.id);
        if (index > -1) {
          this.selected_filters.splice(index, 1);
        } else {
          this.selected_filters.push(obj.id);
        }
      } else {
        this.selected_filters.push(obj.id);
      }
    },
    changeText(text) {
      text = text.replace(/[-][0-9]*/g, "");
      return text;
    },
    filterPage() {
      this.family = this.$route.params.family;
      this.$store.dispatch("Products/getProductsFiltered", {
        filter: this.selected_filters,
        family: this.family,
      });
    },
    filterPageByFamily() {
      this.family = this.$route.params.family;
      this.$store.dispatch("Products/getProductsFiltered", {
        family: this.family,
      })
    },

    setFilter() {
      this.family = this.$route.params.family;
      this.$store.dispatch("Products/FilterStore/setFilterList", {
        family: this.family,
      });
    }
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch("Publicity/getPublicities", this.$route.name);
    if (!this.filterStore.subfamily) {
      this.setFilter();
      this.filterPageByFamily();
    }
    this.isLoading = false;
  },
  watch: {
    filterStore: {
      async handler(newValue) {
        this.isLoading = true;
        if (Object.keys(this.filterStore).length > 0) {
          if (newValue && newValue.subfamily) {
            const arrayFilter = newValue.subfamily ?? [];
            if (arrayFilter) {
              let filter_name = `${arrayFilter.name}-${arrayFilter.id}`;
              this.selected = [];
              this.selected[0] = filter_name;
              this.selected_filters = [];
              this.selected_filters[0] = arrayFilter.id;
              this.filterPage();
            } else {
              this.selected = [];
              this.selected_filters = [];
              this.filterPageByFamily();
            }
          }
        } else {
          this.selected = [];
          this.selected_filters = [];
          this.filterPageByFamily();
          this.setFilter();
        }
        this.isLoading = false;
      },
      immediate: true
    },
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  width: 100%;
  margin-top: 230px;
  padding-bottom: 50px;

  @media screen and (max-width: 991px) {
    margin-top: 260px;
  }
}

.content-products {
  width: 100%;

  .brand-filter {
    @media screen and (max-width: 991px) {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
      padding: 0;

      .content-brand {
        margin-bottom: 0;

        .btn-return {
          height: 45px;
          width: 96px;
          margin-right: 0;
        }
      }

      .btn-filter {
        all: unset;
        display: flex;
        cursor: pointer;
        width: 126px;
        height: 45px;
        border: none;
        border-radius: 10px;
        background: var(--green-medium);
        color: var(--white);
        display: flex !important;
        align-items: center;
        justify-content: center;
        gap: 10px;

        p {
          font-family: "Font Regular";
          font-size: 18px;
          text-transform: none;
          margin-bottom: 0;
          padding: 0;
          color: var(--white);
        }

        img {
          width: 18px;
          height: 15px;
        }
      }
    }
  }

  &-title {
    text-align: left;
    padding-top: 30px;
    margin-bottom: 40px;

    @media (max-width: 991px) {
      padding-top: 0px;
    }

    h1 {
      font-size: 25px;
      font-family: "Font Regular";
      color: var(--green-dark);
      margin-bottom: 0;

      @media (max-width: 991px) {
        font-size: 18px;
      }

      span {
        display: block;
        font-size: 35px;
        font-family: "Font Bold";
        color: var(--green-medium);

        @media (max-width: 991px) {
          font-size: 22px;
        }
      }
    }
  }

  &-body {
    display: flex;
    flex-direction: row;

    @media screen and (max-width: 992px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }

    @media screen and (max-width: 768px) {
      max-width: 100%;
    }

    .content-filter {
      padding: 30px;
      background: #f3f8f4;
      border-radius: 10px;

      @media (max-width: 991px) {
        position: fixed;
        width: 100%;
        max-width: 363px;
        top: 0;
        right: -100%;
        height: 100%;
        padding: 20px;
        overflow-y: auto;
        border-radius: 0;
        z-index: 30;
        transition: 800ms ease-in-out;
      }

      &-btn {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        padding-bottom: 15px;
        margin-bottom: 15px;

        &-close {
          width: 62px;
          height: 53px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          padding-top: 10px;
          text-decoration: none !important;
          border: 1px solid var(--green-medium);
          border-radius: 10px;
          background: #f3f8f4;
          padding: 0;

          img {
            max-width: 24px;
          }

          p {
            font-size: 10px;
            color: var(--green-medium);
            font-family: "Font Light";
            text-align: center;
            margin-bottom: 0px;
          }
        }
      }

      &-elements {
        &-title {
          text-align: left;
          margin-bottom: 10px;

          p {
            font-size: 22px;
            font-family: "Font Bold";
            color: var(--green-dark);
            margin-bottom: 0;
          }
        }

        &-selected {
          .content-items-selected {
            display: flex;
            align-items: center;
            padding: 10px 0px;
            transition: 500ms;

            &:hover,
            &:focus {
              cursor: pointer;
              opacity: 0.8;
            }

            &-btn {
              all: unset;
              display: flex;
              align-items: center;

              p {
                font-size: 18px;
                font-family: "Font Regular";
                color: var(--green-dark);
                text-align: left;
                margin-left: 8px;
                margin-bottom: 0;
              }
            }
          }
        }

        &-collapse {
          padding: 10px 0px;

          .btn-collapse {
            display: flex;
            align-items: center;
            width: 100%;
            background: 0;
            border: 0;
            padding-bottom: 15px;
            border-bottom: 1px solid #b7b8b8;
            padding-left: 0;
            padding-right: 0;
            text-align: left;

            p {
              font-size: 22px;
              font-family: "Font Bold";
              color: var(--green-medium);
              margin-right: 15px;
              margin-bottom: 0;
            }

            svg {
              transform: rotate(180deg);
              transition: 500ms;
            }

            &[aria-expanded="true"] {
              svg {
                transform: rotate(0);
              }
            }
          }

          .content-collapse {

            //padding-bottom: 35px;
            &-input-check {
              display: flex;
              flex-direction: column;
              width: 100% !important;
              //align-items: center;
              padding: 15px 0px;

              // &:first-child {
              //   padding-top: 30px;
              // }
              &:last-child {
                padding-bottom: 0;
              }

              input[type="checkbox"]:checked:before {
                content: "";
                height: 100%;
                width: 100%;
                background: url("~@/assets/img/icons/check.png");
                background-position: center !important;
                background-repeat: no-repeat !important;
                background-color: var(--white);
              }

              input[type="checkbox"]:before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                background-color: var(--white);
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 5px;
                border: 0;
              }

              input[type="checkbox"] {
                position: relative;
                height: 25px;
                width: 25px;
                border-radius: 5px;
                border: 1px solid #707070;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                outline: 0 !important;
                margin: 0;
                margin-right: 10px;
              }

              label {
                font-size: 16px;
                font-family: "Font Regular";
                color: #555555;
                width: calc(100% - 42px);
                text-align: left;
                margin-bottom: 0;
              }
            }
          }
        }
      }

      .btn-send-filter {
        width: 160px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--green-medium);
        border: 1px solid var(--green-medium);
        border-radius: 10px;
        font-size: 22px;
        font-family: "Font Regular";
        color: var(--white);
        margin: 30px auto 0px auto;
        transition: 500ms;

        &:hover,
        &:focus {
          cursor: pointer;
          background: var(--white);
          color: var(--green-medium);

          svg {
            fill: var(--green-medium);
          }
        }

        @media (max-width: 991px) {
          width: 130px;
          height: 45px;
          font-size: 20px;
          border-radius: 5px;
          margin: 30px auto 0px auto;
        }
      }
    }

    .content-ads {
      padding: 30px;
      background: #f2f2f2;
      border-radius: 10px;
      margin-top: 30px;

      @media (max-width: 991px) {
        margin-top: 0;
        margin-bottom: 30px;
      }

      &-banner {
        margin-bottom: 40px;

        @media (max-width: 991px) {
          margin-bottom: 30px;
        }
      }
    }
  }
}

.active-filter-categories {
  right: 0 !important;
  opacity: 1 !important;
  pointer-events: initial !important;
}

.form-check {
  display: flex !important;
  padding: 10px 0 !important;
  width: 100% !important;
}

.content-check {
  display: flex;
  align-items: center;
}
</style>